// extracted by mini-css-extract-plugin
export var container = "style-module--container--39bdd";
export var copyright = "style-module--copyright--21ba2";
export var phone_number = "style-module--phone_number--06a63";
export var phone_number_link = "style-module--phone_number_link--9e875";
export var privacy_policy_link = "style-module--privacy_policy_link--ff712";
export var sns = "style-module--sns--1a31f";
export var sns_list = "style-module--sns_list--244b5";